<template>
    <div>
        <div v-if="video" class="columns">
            <div class="column">
                <video-player :video-id="video.id" />
            </div>
        </div>

        <div v-if="video" class="columns">
            <div class="column">
                <h4 class="title is-4">{{ video.title }}</h4>

                <p v-if="video.caption" class="has-text-subtle">
                    {{ video.caption }}
                </p>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <e-field>
                    <display-content :content="activityContent.content" />
                </e-field>
            </div>
        </div>

        <div v-if="activity.activity_settings.acknowledgment && !readOnly" class="m-b-md">
            <e-field label="Acknowledgment">
                <e-checkbox v-if="!completed" v-model="userAccepted">
                    {{ activity.activity_content.acknowledgment_message }}
                </e-checkbox>

                <!-- eslint-disable-next-line vue/prefer-true-attribute-shorthand -->
                <e-checkbox v-else disabled model-value>
                    {{ activity.activity_content.acknowledgment_message }}
                </e-checkbox>
            </e-field>
        </div>

        <div v-if="userHasAuthorizedAttempt || (!completed && !readOnly)" class="columns">
            <div class="column is-4">
                <e-button :loading="isLoading" :disabled="disable" type="is-primary" @click="submit" @keyup="submit">
                    {{ translate('mark_complete') }}
                </e-button>
            </div>
        </div>

        <div v-if="!readOnly && canViewSubmissions" class="columns">
            <div class="column">
                <submissions :namespace="namespace" @fetch-submissions="toggleSubmissionLoading" />
            </div>
        </div>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { mapState } from 'vuex';

import Submissions from '@/components/activity-types/course-activity-types/activities/Submissions.vue';
import DisplayContent from '@/components/editor/DisplayContent.vue';
import VideoPlayer from '@/components/videos/VideoPlayer.vue';
import AttemptAuthorizationMixin from '@/mixins/AttemptAuthorization.mixin.js';
import CourseActivityMixin from '@/mixins/CourseActivity.mixin.js';
import IsLateMixin from '@/mixins/IsLate.mixin.js';
import axios from '@/plugins/axios.js';

export default {
    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },
    name: 'VideoTemplate',

    components: {
        DisplayContent,
        Submissions,
        VideoPlayer,
    },

    mixins: [IsLateMixin, CourseActivityMixin, AttemptAuthorizationMixin],

    data: () => ({
        video: null,
        userAccepted: false,
    }),

    computed: {
        ...mapState('Auth', { authUser: state => state.user }),

        payload() {
            return {
                uuid: this.activity.uuid,
                course_id: this.$route.params.courseId,
                activity_id: this.$route.params.activityId,
                activity_type: this.get('activity_type'),
                activity_submission: { acknowledgment: this.userAccepted },
            };
        },

        disable() {
            if (this.activity.activity_settings.acknowledgment) {
                return this.disabled || !this.userAccepted;
            }

            return this.disabled;
        },
    },

    watch: {
        completed(completed) {
            if (completed) {
                this.userAccepted = true;
            }
        },
    },

    async created() {
        const id = await this.$store.getters[`${this.namespace}/get`](this.uuid).id;

        const endpoint = this.namespace === 'Activities' ? 'activities' : 'activity-templates';

        const { data } = await axios.get(`/api/${endpoint}/${id}?include=contentable.video`);

        const referenceId = data.data.activity_content.video.reference_id;

        this.video = await this.$store.dispatch('Videos/fetchOne', referenceId);
    },
};
</script>
